import { apiFetch } from './client';
import type { Project } from '@/types/models';

export async function listProjects(): Promise<{ projects: Project[] }> {
  return apiFetch('/api/projects');
}

export async function createProject(input: {
  name: string;
  parentId?: string | null;
}): Promise<Project> {
  return apiFetch('/api/projects', { method: 'POST', body: JSON.stringify(input) });
}

export async function updateProject(
  id: string,
  input: { name?: string; parentId?: string | null },
): Promise<Project> {
  return apiFetch(`/api/projects/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export async function deleteProject(id: string): Promise<void> {
  await apiFetch(`/api/projects/${id}`, { method: 'DELETE' });
}

export async function duplicateProject(
  id: string,
  targetParentId: string | null,
): Promise<Project> {
  return apiFetch(`/api/projects/${id}/duplicate`, {
    method: 'POST',
    body: JSON.stringify({ targetParentId }),
  });
}
